import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { environment } from '@env/environment';
import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from '@global';
import { version } from '@env/version';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  @Input() isSvbPage: boolean;

  readonly env = environment;
  readonly version = version;
  readonly TERMS_OF_USE_URL = TERMS_OF_USE_URL;
  readonly PRIVACY_POLICY_URL = PRIVACY_POLICY_URL;

  constructor() {}

  ngOnInit() {}
}
